import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/global.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { LoginService } from '../../../Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalService } from 'src/app/Services/local.service';
import { DashboardService } from 'src/app/Modules/dashboard/Services/dashboard.service';
import * as moment from 'moment';

export interface usertype {
  value: string;
  viewValue: string;
}
export interface sendtype {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  forgetForm: FormGroup;
  captcha: any;
  crdate: any;
  loginUsrType: any;
  private passType = "password"

  usertypes: usertype[] = [
    { value: 'AGN', viewValue: 'Agent' },
    { value: 'Admin', viewValue: 'Admin' },
    { value: 'CSR', viewValue: 'CSR' }

  ];
  sendtypes: sendtype[] = [
    { value: 'Mail', viewValue: 'Mail' }, 
    { value: 'SMS', viewValue: 'SMS' }
  ];

  constructor(private _formbuilder: FormBuilder, private dashBoardService: DashboardService, private router: Router, public global: GlobalService, private local: LocalService,
    public dialog: MatDialogRef<LoginComponent>, public loginService: LoginService, public toastr: ToastrService, public spinner: NgxSpinnerService, public _global: GlobalService, public loginservice: LoginService) {

    this.loginForm = this._formbuilder.group({
      userName: ['', [Validators.required, Validators.maxLength(16), Validators.pattern('^[a-zA-Z0-9]+$')]],
      password: ['', [Validators.required, Validators.maxLength(10)]],
      //modeType :['',[Validators.required]],
      captcha: ['']
    })

    this.forgetForm = this._formbuilder.group({
      username: ['', [Validators.required, Validators.maxLength(16), Validators.pattern('^[a-zA-Z0-9]+$')]],
      sendtype: ['', [Validators.required]]
      //usertype: ['']
    })
  }

  // login(loginForm) {
  //   console.log('loginForm->', loginForm)
  //   if (loginForm.userName != '' && loginForm.password != 'password') {
  //     if (loginForm.userName == 'admin' && loginForm.password == 'admin') {
  //       this.global.loginStatus = true;
  //       console.log('I am in')
  //       sessionStorage.setItem("agentId", 'AG0192');
  //       this.dialog.close();
  //       this.router.navigate(["listing/policyListing"])
  //       return;
  //     }
  //   } else {

  //   }

  //   // this.router.navigate(["/usercreation"])
  //   // return;

  //   // if(this.loginForm.valid){
  //   //this.loginService.login(this.loginForm.value)
  //   // alert("sa"+this.loginForm.value.userName);
  //   console.log(this.loginForm.value);

  //   //  For Admin Login
  //   if (this.loginUsrType == "Admin") {
  //     // if(this.loginForm.value.userName == "admin" && this.loginForm.value.password == "admin"){
  //     if (this.captcha == loginForm.captcha) {

  //       this.loginService.login(loginForm).subscribe((data: any) => {

  //         if (data.responseBody.message != "" && null != data.responseBody.message) {
  //           this.toastr.error(data.responseBody.message, undefined, {
  //             positionClass: 'toast-bottom-right',
  //             timeOut: 1000
  //           });
  //           this.loginForm.patchValue({
  //             userName: '',
  //             password: '',
  //             captcha: ''
  //           })
  //         }
  //         else if (data.responseBody.agentId != "" && null != data.responseBody.agentId) {
  //           console.log("Agent Data : ", data.responseBody)
  //           sessionStorage.setItem("agentId", data.responseBody.agentId);
  //           sessionStorage.setItem("modeType", data.responseBody.modeType);
  //           sessionStorage.setItem("agentName", data.responseBody.agentName);
  //           sessionStorage.setItem("userName", data.responseBody.userName);
  //           sessionStorage.setItem("userType", data.responseBody.modeType);
  //           sessionStorage.setItem("agentDob", data.responseBody.dob);
  //           sessionStorage.setItem("adminEmailId", data.responseBody.emailId);
  //           sessionStorage.setItem("admnProfileName", data.responseBody.profileName);
  //           sessionStorage.setItem("passwordYN", data.responseBody.passwordYN);


  //           this.global.loginStatus = true;
  //           this.global.loginName = data.responseBody.agentName;
  //           sessionStorage.setItem("loginpassword", this.loginForm.value.password);
  //           this.dialog.close();
  //           this.router.navigate(["/usercreation"])
  //         }
  //         else {
  //           this.toastr.error("Entered Username and Password is Incorrect", undefined, {
  //             positionClass: 'toast-bottom-right',
  //             timeOut: 6000
  //           });
  //         }
  //       })
  //     }
  //     else {
  //       
  //       this.loginForm.patchValue({
  //         captcha: ''
  //       })
  //       this.toastr.error("Entered Captcha is Incorrect", undefined, {
  //         positionClass: 'toast-bottom-right',
  //         timeOut: 6000
  //       });
  //     }
  //     // alert("sa1"+this.loginForm);

  //     //   }else{
  //     //     this.toastr.error("Entered Username and Password is Incorrect", undefined, {
  //     //       positionClass: 'toast-bottom-right',
  //     //       timeOut: 6000
  //     //  });
  //     //  this.loginForm.patchValue({
  //     //   userName:'',
  //     //   password:'',
  //     //   captcha:''
  //     // })
  //     //   }
  //   }
  //   //  For Agent Login
  //   else {
  //     if (this.loginForm.valid) {
  //       if (this.captcha == loginForm.captcha) {
  //         
  //         //to check for password expiry
  //         //    var username = loginForm.userName;
  //         //    this.dashBoardService.passwordexpiry(username).subscribe((data:any)=>{
  //         //      
  //         //      console.log(data);
  //         //      var resdate = data.responseBody.Detail;
  //         //      var d = moment(resdate).format("DD/MM/YYYY");
  //         //      this.crdate = new Date(resdate);                   
  //         //      console.log(d);
  //         //      // to get the next month date 
  //         //      
  //         //    var date =this.crdate;
  //         //    var ldate = date.setMonth(date.getMonth() + 1);
  //         //    var losdate =new Date(ldate);
  //         //    var lossdate= moment(losdate).format("DD/MM/YYYY");
  //         //    console.log(lossdate);
  //         //    //current date
  //         //    var curdate = new Date();
  //         //   var currentdate = moment(curdate).format("DD/MM/YYYY"); 
  //         // if(curdate > losdate){
  //         //   
  //         //   let obj = {         
  //         //     username: loginForm.userName,
  //         //     flag : "Y",
  //         //   }
  //         //   this.dashBoardService.passwordexpirymail(obj).subscribe((data:any)=>{
  //         //     
  //         //     console.log(data.responseBody);
  //         //     this.toastr.warning("Your password has been expired,new password sent to your registered mail Id", undefined, {
  //         //       positionClass: 'toast-bottom-right',
  //         //       timeOut: 6000
  //         //   });  
  //         //   })
  //         //  }
  //         // else{  
  //         this.loginService.login(loginForm).subscribe((data: any) => {
  //           
  //           if (data.responseBody.message != "" && null != data.responseBody.message) {
  //             this.toastr.error(data.responseBody.message, undefined, {
  //               positionClass: 'toast-bottom-right',
  //               timeOut: 6000
  //             });
  //             this.loginForm.patchValue({
  //               userName: '',
  //               password: '',
  //               captcha: ''
  //             })
  //           }
  //           else if (data.responseBody.agentId != "" && null != data.responseBody.agentId) {
  //             console.log("Agent Data : ", data.responseBody)
  //             sessionStorage.setItem("agentId", data.responseBody.agentId);

  //             sessionStorage.setItem("modeType", data.responseBody.modeType);


  //             this.global.agentName = data.responseBody.userName;
  //             sessionStorage.setItem("agentName", data.responseBody.agentName);

  //             this.global.agentName = data.responseBody.userName;
  //             sessionStorage.setItem("userName", data.responseBody.userName);
  //             sessionStorage.setItem("userType", data.responseBody.modeType);
  //             sessionStorage.setItem("agentDob", data.responseBody.dob);
  //             sessionStorage.setItem("agentEmailId", data.responseBody.emailId);
  //             sessionStorage.setItem("agentProfileName", data.responseBody.profileName);
  //             sessionStorage.setItem("firstTimeLogin", "true");
  //             sessionStorage.setItem("langFlag", "true");
  //             sessionStorage.setItem("activetime", "true");
  //             sessionStorage.setItem("passwordYN", data.responseBody.passwordYN);
  //             sessionStorage.setItem("loginpassword", data.responseBody.password);
  //             this.global.usertype = data.responseBody.modeType;
  //             this.global.loginName = data.responseBody.name;
  //             // this.global.userData = res.responseBody;        
  //             this.local.setObject("loginDetails", data.responseBody);
  //             this.local.setString("token", data.responseBody.token);

  //             this.dialog.close();
  //             if (this.global.usertype == "CSR") {
  //               this.router.navigate(["dashboard/csr-dashboard"]);
  //             } else {
  //               this.router.navigate(["dashboard/dashboard"]);
  //             }
  //             this.spinner.hide();
  //           }
  //           else {
  //             this.toastr.error("Entered Username and Password is Incorrect", undefined, {
  //               positionClass: 'toast-bottom-right',
  //               timeOut: 6000
  //             });
  //             this.loginForm.patchValue({
  //               userName: '',
  //               password: '',
  //               captcha: ''
  //             })
  //           }
  //         })
  //         //}
  //         //})
  //       }
  //       else {
  //         
  //         this.toastr.error("Entered Captcha is Incorrect", undefined, {
  //           positionClass: 'toast-bottom-right',
  //           timeOut: 6000
  //         });
  //         this.loginForm.patchValue({
  //           captcha: ''
  //         })
  //       }
  //     } else {
  //       if (this.loginForm.value.userName == null || this.loginForm.value.userName == "") {
  //         this.loginForm.patchValue({
  //           userName: ''
  //         })
  //         this.toastr.error("Please Enter UserName", undefined, {
  //           positionClass: 'toast-bottom-right',
  //           timeOut: 6000
  //         });
  //       } else if (this.loginForm.value.password == null || this.loginForm.value.password == "") {
  //         this.loginForm.patchValue({
  //           password: ''
  //         })
  //         this.toastr.error("Please Enter Password", undefined, {
  //           positionClass: 'toast-bottom-right',
  //           timeOut: 6000
  //         });
  //       } else if (this.loginForm.value.captcha == null || this.loginForm.value.captcha == "") {
  //         this.loginForm.patchValue({
  //           captcha: ''
  //         })
  //         this.toastr.error("Please Enter Captcha", undefined, {
  //           positionClass: 'toast-bottom-right',
  //           timeOut: 6000
  //         });
  //       }
  //     }
  //   }

  //   
  //   //For session timing
  //   
  //   var code = "01";
  //   this.loginservice.settime(code).subscribe((res: any) => {
  //     
  //     console.log(res);
  //     if (res.responseBody != undefined) {
  //       
  //       this._global.time = res.responseBody.time;
  //     }
  //   })
  //   //ended 

  // }  
  login(loginForm) { 
    if (loginForm.userName != '' && loginForm.password != '') {
      let obj = {
        "username": loginForm.userName,
        "password": loginForm.password
      }
      this.loginservice.login(obj).subscribe((res: any)=>{  
                  if(res.responseType == "SUCCESS"){ 
                        this.global.loginStatus = true;
                        this.global.providerCode = res.responseBody.providerCode;
                        this.global.role = res.responseBody.role;
                        this.global.username = res.responseBody.username;  
                        this.local.setString("token",res.responseBody.token);
                        this.local.setString("providerCode",res.responseBody.providerCode);
                        this.local.setString("userName",res.responseBody.username);
                        this.local.setString("role",res.responseBody.role);
                        
                        sessionStorage.setItem("role",res.responseBody.role);  
                        sessionStorage.setItem("token",res.responseBody.token); 
                        sessionStorage.setItem("dispName",res.responseBody.dispName);
                        sessionStorage.setItem("agentId",res.responseBody.agentId);
                        sessionStorage.setItem("userName",res.responseBody.username);
                        sessionStorage.setItem("loginpassword",res.responseBody.username);
                        sessionStorage.setItem("providerCode",res.responseBody.providerCode);
                         console.log('I am in');
                        //sessionStorage.setItem("agentId", 'AG0192');
                        
                        
                        this.dialog.close();
                        if(this.global.role == "admin" || this.global.role == "broker" || this.global.role == "agent"){
                          this.router.navigate(["listing/intimationListing"]) 
                        }
                        else{
                          this.router.navigate(["listing/Pre-Auth"]) 

                        }


                      return;
                  }
                  else if(res.responseType == "FAIL"){

                    if(res.responseBody.errorCode == "000"){
                      if(this._global.selectLang == "vn" ){
                        this.toastr.error("Tên đăng nhập hoặc mật khẩu không đúng", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                      }
                      else{
                        this.toastr.error("Incorrect user name or password", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                      }

                    }
                    if(res.responseBody.errorCode == "100009"){
                      if(this._global.selectLang == "vn" ){ 
                         this.toastr.error("Tên đăng nhập không đúng", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                      }
                      else{
                        this.toastr.error("User is not available for the entered details", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                      }
                    }

                  }
                  // else{
                
                  //       if(this._global.selectLang == "vn" ){
                  //         this.toastr.error("Thông tin không hợp lệ", undefined, {
                  //           positionClass: 'toast-bottom-right',
                  //           timeOut: 6000
                  //         });
                  //       }
                  //       else{
                  //         this.toastr.error("Invalid Credentials", undefined, {
                  //           positionClass: 'toast-bottom-right',
                  //           timeOut: 6000
                  //         });
                  //       }
                  // }
      });  
    }  
    else { 
                  if (loginForm.userName == '') {  
                        if(this._global.selectLang == "vn" ){
                          this.toastr.error("Nhập tên đăng nhập", undefined, {
                            positionClass: 'toast-bottom-right',
                            timeOut: 6000
                          });
                        }
                        else{
                          this.toastr.error("Enter Username", undefined, {
                            positionClass: 'toast-bottom-right',
                            timeOut: 6000
                          });
                        } 
                  } else if (loginForm.password == '') {  
                        if(this._global.selectLang == "vn" ){
                        
                        this.toastr.error("Nhập mật khẩu", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                        }
                        else{
                          
                        this.toastr.error("Enter Password", undefined, {
                          positionClass: 'toast-bottom-right',
                          timeOut: 6000
                        });
                        } 
                  } 

    }


  }



  forget() {
    
    if (this.forgetForm.valid) {
      
      var username = this.forgetForm.get('username').value;
      var type = this.forgetForm.get('sendtype').value;
      this.loginService.forgetForm(username, type).subscribe((res: any) => {
        if (res.responseType == "SUCCESS") {
          this.dialog.close();
        }
        if (res.responseBody.validationMsg) {
          this.toastr.success(res.responseBody.validationMsg, undefined, {
            positionClass: 'toast-bottom-right',
            timeOut: 6000
          });
        }
      })
    } else {
      this.toastr.error("Please Fill the Mandatory Fields", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
    }
  }


  //to hide the forms based on selection
  testclick() {
    
    document.getElementById('loginformid').style.display = "none";
    document.getElementById('forgetformid').style.display = "block";

  }
  cancelclick() {
    document.getElementById('loginformid').style.display = "block";
    document.getElementById('forgetformid').style.display = "none";

  }
  //end


  ngOnInit() { 
    this.global.providerCode = "";
    this.global.role ="";
    this.global.username = "";
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
    // You can include special characters by adding them to the string above, for eg: chars += "@#?<>";

    var string_length = 4; // This is the length of the Captcha    
    var ChangeCaptcha = '';
    for (var i = 0; i < string_length; i++) {
      var rnum = Math.floor(Math.random() * chars.length);
      this.captcha += chars.substring(rnum, rnum + 1);
    }
    var lastFour = this.captcha.substr(this.captcha.length - 4);
    this.captcha = lastFour;
    localStorage.setItem("captcha", this.captcha);
    console.log(this.captcha);

  }

  reCaptcha() {
    
    var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";

    var string_length = 4; // This is the length of the Captcha    
    var ChangeCaptcha = '';
    for (var i = 0; i < string_length; i++) {
      var rnum = Math.floor(Math.random() * chars.length);
      this.captcha += chars.substring(rnum, rnum + 1);
    }
    var lastFour = this.captcha.substr(this.captcha.length - 4);
    this.captcha = lastFour;
    localStorage.setItem("captcha", this.captcha);
    console.log(this.captcha);
    this.loginForm.patchValue({
      captcha: ''
    })
  }

  validateUsername() {
    
    var userName = this.forgetForm.value.username;
    this.loginService.validateUsername(userName).subscribe((res: any) => {
      
      if (res.responseBody.validationMsg == "Entered Username is Present") {
      } else {
        this.toastr.error(res.responseBody.validationMsg, undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
        });
        this.forgetForm.patchValue({
          username: ''
        })
      }
    })
  }

  showPwd() {
    
    if (this.passType == "password") {
      this.passType = "text";
    } else {
      this.passType = "password";
    }
  }

  userNamechange() {
    
    var userName = this.loginForm.value.userName;
    this.loginService.userNamechange(userName).subscribe((res: any) => {
      
      if (res.responseBody.UserType != undefined) {
        this.loginUsrType = res.responseBody.UserType;
      }
    })


  }
}
